module.exports = __webpack_public_path__ + "img/s1_t1_27.92b51a6f.jpeg";